// src/features/inventory/hooks/useMSDS.js
import { useState, useCallback } from 'react';
import { msdsAPI } from '../services/msds';
import { useApi } from '../../../hooks/api/useApi';

export function useMSDS() {
  const [msds, setMSDS] = useState(null);
  const [history, setHistory] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchMSDS = useCallback(async (itemId) => {
    const result = await execute(() => msdsAPI.getMSDS(itemId));
    if (result?.success) {
      setMSDS(result.data.data);
    } else {
      setMSDS(null);
    }
    return result;
  }, [execute]);

  const fetchHistory = useCallback(async (itemId) => {
    const result = await execute(() => msdsAPI.getMSDSHistory(itemId));
    if (result?.success) {
      setHistory(result.data.data || []);
    }
    return result;
  }, [execute]);

  const createMSDS = useCallback(async (itemId, body) => {
    const result = await execute(() => msdsAPI.createMSDS(itemId, body));
    if (result?.success) {
      setMSDS(result.data.data);
    }
    return result;
  }, [execute]);

  const updateMSDS = useCallback(async (itemId, body) => {
    const result = await execute(() => msdsAPI.updateMSDS(itemId, body));
    if (result?.success) {
      setMSDS(result.data.data);
    }
    return result;
  }, [execute]);

  const deleteMSDS = useCallback(async (itemId) => {
    const result = await execute(() => msdsAPI.deleteMSDS(itemId));
    if (result?.success) {
      setMSDS(null);
    }
    return result;
  }, [execute]);

  return {
    msds,
    history,
    loading,
    error,
    clearError,
    fetchMSDS,
    fetchHistory,
    createMSDS,
    updateMSDS,
    deleteMSDS,
  };
}
